export default {
  setInquiryList(state, payload) {
    state.inquiryList = payload || { rows: [], meta: {}, stats: { status_breakdown: [] } };
  },
  setInquiry(state, inquiry) {
    state.inquiry = inquiry;
  },
  resetInquiry(state) {
    state.inquiry = null;
  }
};
